import CONFIG from "../../model/TSConfig";
import { DistributionPlace } from "../../model/DistributionPlace";
import normalizeString from "./normalizeString";
import { POSATypeJavascriptDTO } from "@tootsweet/model/lottery/POSAType";

export const getGameURL = (props: {
  place: DistributionPlace;
  posa?: POSATypeJavascriptDTO;
  configID?: string;
}) => {
  switch (props.place) {
    case DistributionPlace.Online:
      return `${CONFIG.jetpackFrontendUrl}/?v=${props.configID}&utm_medium=qrcode&utm_source=social_networks`;
    case DistributionPlace.QRCode:
      return `${CONFIG.jetpackFrontendUrl}/?v=${props.configID}&utm_medium=qrcode`;
    case DistributionPlace.PLV:
      if (!props.posa) {
        throw new Error("Must provide POSA");
      }
      const utm_source = normalizeString(props.posa.format);
      const utm_campaign = normalizeString(props.posa.shortId);
      let query = "";
      if (utm_campaign) {
        query += "&utm_campaign=" + utm_campaign;
      }
      if (utm_source) {
        query += "&utm_source=" + utm_source;
      }
      return `${CONFIG.jetpackFrontendUrl}/?v=${props.configID}&utm_medium=qrcode${query}`;
  }
};
